export const enum ScrollToAnchor {
  Group = 'groupnumber',
  Package = 'packagenumber',
  Tariff = 'tariffnumber'
}

export type ScrollToAnchorDataAttributes = Record<ScrollToAnchor, string>;
